import './login.scss';

import { Button } from '@myome/ui';

import Header from '@components/Header/HeaderNav';
import useApp from '@hooks/useApp';
import loginLgImage from '@statics/images/login-images/login-lg.webp';
import loginMdImage from '@statics/images/login-images/login-md.webp';
import loginSmImage from '@statics/images/login-images/login-sm.webp';
import loginXlImage from '@statics/images/login-images/login-xl.webp';
import loginXsImage from '@statics/images/login-images/login-xs.webp';

function Login() {
  const { isLoggedIn, onLogin } = useApp();

  return (
    <div data-testid='login_page'>
      <Header />
      <main className='login-page-wrapper'>
        <div className='login-left-half'>
          <img
            data-sizes='auto'
            alt='patient login image'
            src={loginXlImage}
            srcSet={`
              ${loginXsImage} 440w,
              ${loginSmImage} 767w,
              ${loginMdImage} 991w,
              ${loginLgImage} 1000w,
              ${loginXlImage} 1236w
            `}
            className='login-img'
          />
        </div>
        <div className='login-right-half'>
          <div className='right-half-content'>
            <h1 className='login-title'>
              One Test <br /> Whole Genome
            </h1>
            <Button dataTestId='loginBtn' className='login-btn' onClick={onLogin} variant='secondary'>
              {isLoggedIn ? 'Go to Home' : 'Login'}
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Login;
